import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, impressaoAlteracaoEndereco } from './types';

export const INITIAL_STATE: impressaoAlteracaoEndereco = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): impressaoAlteracaoEndereco {
	return produce(state, draft => {
		switch (action.type) {
			case Types.IMPRESSAO_ALTERACAO_ENDERECO_REQUEST: {
				break;
			}

			case Types.IMPRESSAO_ALTERACAO_ENDERECO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.IMPRESSAO_ALTERACAO_ENDERECO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			default:
		}
		return draft;
	});
}
